import { render, staticRenderFns } from "./DynamicTableCell.vue?vue&type=template&id=f2d9c954&scoped=true"
import script from "./DynamicTableCell.vue?vue&type=script&lang=js"
export * from "./DynamicTableCell.vue?vue&type=script&lang=js"
import style0 from "./DynamicTableCell.vue?vue&type=style&index=0&id=f2d9c954&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2d9c954",
  null
  
)

export default component.exports